import { render } from "./CheckpointVehicle.vue?vue&type=template&id=f1c2ee68"
import script from "./CheckpointVehicle.vue?vue&type=script&lang=js"
export * from "./CheckpointVehicle.vue?vue&type=script&lang=js"
script.render = render

export default script